<template>
	<div class="home">
		<FiltroPeriodoInicio
			v-if="!perfilAdmin"
			:periodo="periodoAplicado"
			:carregando="carregandoDashboard"
			@aplicar="aplicarPeriodo"
		/>

		<InicioAdmin v-if="perfilAdmin" />
		<InicioColaborador v-if="perfilColaborador" :periodo="periodoAplicado"
			@carregando="alterarCarregamento" />
		<InicioCoordenador v-if="perfilCoordenador" :periodo="periodoAplicado"
			@carregando="alterarCarregamento" />
		<InicioDiretor v-if="perfilDiretor" :periodo="periodoAplicado"
			@carregando="alterarCarregamento" />

	</div>
</template>

<script>
import InicioAdmin from "@/components/InicioAdmin.vue";
import InicioColaborador from "@/components/InicioColaborador.vue";
import InicioCoordenador from "@/components/InicioCoordenador.vue";
import InicioDiretor from "@/components/InicioDiretor.vue";
import FiltroPeriodoInicio from "@/components/FiltroPeriodoInicio.vue";

export default {
	name: "home",
	components: {
		InicioAdmin,
		InicioColaborador,
		InicioCoordenador,
		InicioDiretor,
		FiltroPeriodoInicio,
	},
	created(){
		this.selecionarPerfil()
	},
	data() {
		const anoAtual = new Date().getFullYear();
		return {
			perfilAdmin: false,
			perfilColaborador: false,
			perfilCoordenador: false,
			perfilDiretor: false,
			periodoAplicado: {
				dataInicio: `01/01/${anoAtual}`,
				dataFim: `31/12/${anoAtual}`,
			},
			carregandoDashboard: false,
		};
	},
	methods: {
		aplicarPeriodo(periodo) {
			this.periodoAplicado = { ...periodo };
		},
		alterarCarregamento(carregando) {
			this.carregandoDashboard = carregando;
		},
		selecionarPerfil() {
			let perfil = localStorage.getItem("pnome");
			this.perfilAdmin = (perfil === "ADMIN");
			this.perfilColaborador = (perfil === "COLABORADOR");
			this.perfilCoordenador = (perfil === "COORDENADOR");
			this.perfilDiretor = (perfil === "DIRETOR");
		}
	}
};
</script>

<style scoped>
.small-box {
    border-radius: .25rem;
    box-shadow: 0 0 4px rgba(0,0,0,.125),0 4px 6px rgba(0,0,0,.2);
    display: block;
    margin-bottom: 20px;
    position: relative;
}
.small-box:hover {
	-webkit-transform: scale(1.015);
	transform: scale(1.015);
}
.inner {
    padding: 10px;
}
.text-35 {
	font-size: 35px;
	font-weight: 700;
	margin: 0;
	padding: 0;
	white-space: nowrap;
	/*margin-bottom: .5rem;*/
	font-family: "Source Sans Pro";
	line-height: 1.2;
}

.text-projeto {
	font-size: 18px;
	font-weight: 700;
}

.small-box-footer {
	background-color: rgba(0,0,0,.1);
	color: rgba(255,255,255,.8);
	display: block;
	padding: 3px 0;
	position: relative;
	text-align: center;
	text-decoration: none;
	z-index: 10;
}
.icon {
	color: rgba(0,0,0,.10);
	font-size: 70px;
	top: 20px;
}
.icone:hover {
	-webkit-transform: scale(1.1);
	transform: scale(1.1);
}
.icone {
	font-size: 65px;
	position: absolute;
	right: 15px;
	top: 15px;
	transition: -webkit-transform .3s linear;
	transition: transform .3s linear;
	transition: transform .3s linear,-webkit-transform .3s linear;
}
</style>

